import React, { memo } from 'react'

import { Button, CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function AssistPosted() {
  const t = useTranslation()

  return (
    <div className="assist-posted">
      <span className="enhance-model-panel__title cgt-heading-50">{t('viewerSidebar.enhance.assist.heading')}</span>

      <div className="assist-posted__content">
        <div className="assist-posted__icon" aria-hidden="true">
          <Icon svgComponent={CircleCheck} />
        </div>

        <div className="assist-posted__text">
          <p className="assist-posted__title cgt-heading-100">{t('viewerSidebar.enhance.assist.posted.title')}</p>
          <p className="assist-posted__description cgt-body-base">
            {t('viewerSidebar.enhance.assist.posted.description')}
          </p>
        </div>
        <Button
          customClass="assist-posted__button"
          type="secondary"
          size="medium"
          href="/profile/projects"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('viewerSidebar.enhance.assist.posted.cta')}
        </Button>
      </div>
    </div>
  )
}

export default memo(AssistPosted)
